import React, { useState } from 'react';
import InputMask from 'react-input-mask';

import Input, { InputProps } from './Input';

interface MaskedInputProps extends InputProps {
  mask: string;
  maskChar?: string;
}
/** @deprecated Use `<MaskedInput></MaskedInput>` instead from reusable components */
const MaskedInput = (props: MaskedInputProps) => {
  const { mask, name, errorContext, label, maskChar = '', onBlur, ...rest } = props;

  const [value, setValue] = useState('');

  return (
    <InputMask
      mask={mask}
      maskChar={maskChar}
      value={value}
      onBlur={onBlur}
      onChange={(e: { target: { value: React.SetStateAction<string> } }) => setValue(e.target.value)}
    >
      {(inputProps: InputProps) => (
        <Input {...inputProps} {...rest} label={label} errorContext={errorContext} name={name} id={name} />
      )}
    </InputMask>
  );
};

export default MaskedInput;
